import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';

var PasswordField =
/*#__PURE__*/
function (_Component) {
  _inherits(PasswordField, _Component);

  function PasswordField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PasswordField);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PasswordField)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      showPassword: false
    }, _this.onShowPasswordClick = function () {
      _this.setState({
        showPassword: !_this.state.showPassword
      });
    }, _temp));
  }

  _createClass(PasswordField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          validate = _this$props.validate;
      return React.createElement('div', null, React.createElement('div', {
        className: 'Password-group'
      }, React.createElement(TextField, {
        type: this.state.showPassword ? 'text' : 'password',
        name: name,
        className: 'form-control',
        label: label,
        placeholder: placeholder,
        validate: validate
      }), React.createElement('div', {
        className: 'Password-icon',
        onClick: this.onShowPasswordClick,
        title: this.state.showPassword ? 'Hide password' : 'Show password'
      }, React.createElement('i', {
        className: this.state.showPassword ? 'icon-ic_eye' : 'icon-ic_eye-slash'
      }))));
    }
  }]);

  return PasswordField;
}(Component);

PasswordField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  validate: PropTypes.array
};
export default PasswordField;